
export const REQUEST_ADDNEWUSER= 'REQUEST_ADDNEWUSER';
export const ADDNEWUSER_RECEIVED = 'ADDNEWUSER_RECEIVED';